'use strict';

(function ( $ ) {
    $(document).ready(function() {
        $(document)
            .on('click', 'a[href="#footer-change-privacy-settings"]', function(e) {
                e.preventDefault();
                window.OneTrust.ToggleInfoDisplay();
            });

    });
}( jQuery ));
